import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { NavigatorService } from 'src/app/core/navigator/navigator.service';
import { SisMapReferenceAdapter } from 'src/app/sismap-reference/domain/sismap-reference.adapter';
import { SisMapReference } from 'src/app/sismap-reference/domain/sismap-reference.model';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SisMapReferenceService {

  constructor(private httpClient: HttpClient, private navigatorService: NavigatorService) {
  }

  async requestSisMapReferenceMaps(): Promise<SisMapReference[]> {
    const url = `${environment.baseUrlApi}/api/sismap/list`;
    return firstValueFrom(
      this.httpClient.get<SisMapReference[]>(url).pipe(
        map((data) => data.map(SisMapReferenceAdapter.adapt)),
        catchError((err) => {
          console.error(err);
          this.navigatorService.navigateToErrorPage();
          return of([]);
        })
      )
    );
  }
}
